export enum PriceDisplayOption {
  ExcludeIncludeVAT = 'ExcludeIncludeVAT',
  IncludesVATLabel = 'IncludesVATLabel',
  ExcludeVATThreshold = 'ExcludeVATThreshold',
  Simple = 'Simple',
}
